export const SERVER_PORT = 9920;
export const SERVER_RECONNECT_TIMEOUT = 2000;
export const SERVER_INIT_SEQUENCE = 0;
export const SERVER_DISCONNECT_SEQUENCE = -1;
export const RCC_PORT = 9921;
export const RCC_RECONNECT_TIMEOUT = 5000;
export const HELPER_PORT = 9929;
export const HELPER_RECONNECT_TIMEOUT = 10000;
export const WEBSOCKET_PING_INTERVAL = 8;
export const WEBSOCKET_PING_TIMEOUT = 5;
export const LOCALHOST = "localhost";

export const BANNER_IMAGE_INTERVAL = 10000;
export const DEFAULT_APP_INTERVAL = 86400;
export const DEFAULT_FORMULA_TAB_LIMIT = 5;
export const DEFAULT_INTENSITY = 160;
export const DEFAULT_MATCHING_ROW_COUNT = 5;
export const DEFAULT_RGB = "#BBBBBB";
export const DEFAULT_SOFTWARE_NAME_LIGHT = "Light";
export const DEFAULT_SPECTRO_DELTA_FILTER = 5;
export const DEFUALT_SOFTWARE_NAME = "Redlike";
export const DESO = "DESO";
export const FLASH_MESSAGES_PANEL_LIMIT = 3;
export const FORMULA_DECIMALS = 5;
export const HELP_ON_REDLIKE = "https://help.on-redlike.com/";
export const HELP_ON_REDLIKE_AUTOTASKS =
    "https://help.on-redlike.com/knowledgebase/my-own-redlike-autotask-description/";
export const HELP_ON_REDLIKE_FILE_TRANSFER = "https://help.on-redlike.com/documentation/file-transfer/";
export const HOURS_IN_DAY = 24;
export const LEVEL_COLOR_1 = "#7A1515";
export const LEVEL_COLOR_2 = "#FFCCCC";
export const MAX_BASE_LIMIT = 30;
export const MAX_BIPP_LIMIT = 30;
export const MAX_COLORANT_AMOUNT = 9999999;
export const MAX_COLORANT_LIMIT = 50;
export const MAX_CUSTOMER_LIMIT = 50;
export const MAX_FANDECK_LIMIT = 500;
export const MAX_FILTER_ITEMS_LIMIT = 500;
export const MAX_FORMULA_LIMIT = 30;
export const MAX_GLOBAL_SEARCH_FORMULA_LIMIT = 1000;
export const MAX_LAST_DISPENSED_LIMIT = 50;
export const MAX_NUMBER_OF_PACKAGES = 100;
export const MAX_NUMBER_OF_PORTS = 65535;
export const MAX_ORDERS_LIMIT = 15;
export const MAX_PRICE_GROUPS_LIMIT = 20;
export const MAX_STATISTICS_LIMIT = 20;
export const MAX_TAB_LIMIT = 20;
export const MAX_TICKET_LIMIT = 20;
export const MAX_ZOOM_LIMIT = 200;
export const MIN_GLOBAL_SEARCH_CHARS_LIMIT = 3;
export const MIN_ZOOM_LIMIT = 50;
export const MORE_INFO_TEXT_LIMIT = 40;
export const NO_LIMIT = -1;
export const QUICK_TINT_ID = -1;
export const QUICK_TINT_NAME = "Quick Tint";
export const REGISTRATION_LICENSE = "http://system.on-redlike.com/license/register/";
export const SUPPORT_EMAIL = "support@deso.cz";
export const SUPPORT_NUMBER = "+420 608 540 590";
export const UNKNOWN_ID = 0;
export const WEBSOCKET_PROTOCOL = "ws://";
export const ZOOM_STEP = 10;

export const SERVER_INIT = 17;
export const DRIVERS_INIT = 5;
export const MACHINE_INIT = 11;
export const PRINTER_INIT = 2;
export const SPECTRO_INIT = 1;
export const RCC_INIT = DRIVERS_INIT + MACHINE_INIT + PRINTER_INIT + SPECTRO_INIT;
export const INITIALIZATION_NUMBER = SERVER_INIT + RCC_INIT;

export const SOFTWARE_CLIENT = "client";
export const SOFTWARE_CLIENT_WITHOUT_RCC = "client_without_rcc";
export const REDLIKE_CLIENT = "Redlike Client";
export const IG_FRONTDESK = "IG Frontdesk";
export const IG_MACHINE = "IG Machine";
export const UNIVERSAL_BASE_SCAN_CODE = "945173";

export const SERVER_CHUNK_SIZE = 1000;

export const BARCODE_SCANNER_TYPING_LIMIT = 300;

export const IG_MACHINE_VISIBLE_ORDERS_COUNT = 3;
export const WEBER_NO_ORDER_NOTE = "NO INFO";
